<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listNaturalness"
        :title-table="$t('Naturalness')"
        module="naturalnessSettingsModule"
        sort-name="nome"
        add-permission="ROLE_NATURALIDADE_INSERIR"
        view-permission="ROLE_NATURALIDADE_CONSULTAR"
        edit-permission="ROLE_NATURALIDADE_ATUALIZAR"
        delete-permission="ROLE_NATURALIDADE_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormNaturalness
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormNaturalness from './forms/FormNaturalness.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormNaturalness,
  },
  computed: {
    ...mapState('naturalnessSettingsModule', {
      listNaturalness: state => state.listNaturalness,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'nome',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'naturalnessSettingsModule/prepareToEditNaturalness',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
